import api from '../utils/api';

export default {
    namespaced: true,
    state: {
        properties: [],
        parent: undefined,
    },
    getters: {},
    /* eslint-disable no-param-reassign */
    mutations: {
        LIST(state, data) {
            state.properties = data || [];
        },
        PARENT_PROP(state, data) {
            state.parent = data || undefined;
        },
    },
    actions: {
        LIST_ALL(context, parent) {
            context.commit('PARENT_PROP', parent);

            let url = '/properties';
            if (context.state.parent) {
                url += `/${context.state.parent}/properties`;
            }

            return api.get(url)
                .then(
                    response => context.commit('LIST', response.data),
                    response => context.commit('errors/ADD', response, { root: true }),
                );
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/properties.js